import { get } from './api'

export const getCurrentUser = () => {
    return get('/me')
}
